import { Revisioned } from '../config';

export const isNotOlderRevision = (
  candidate: Revisioned,
  current: Revisioned,
): boolean =>
  (candidate.Revision?.Number ?? 0) >= (current.Revision?.Number ?? 0);
